// Reports.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import config from '../../config';
import './Reports.css';
import AlertModal from "../AlertModal/AlertModal";
import useAuth from "../../Auth/useAuth";

axios.defaults.baseURL = config.BASE_URL;


const Reports = () => {

  const Navigate = useNavigate();

  // const [filterReports, setFilterReports] = useState({
  //   startDate: '',
  //   endDate: '',
  //   vendor: '',
  //   truckNumber: ''
  // });

  const { userProfile, setTripIDState, moduleChange, setModuleChange, activeModule, setActiveModule } = useAuth();

  const [vendors, setVendors] = useState([]);
  const [truckNumbers, setTruckNumbers] = useState([]);
  const [vendorQuery, setVendorQuery] = useState('');
  const [truckQuery, setTruckQuery] = useState('');
  const [showVendorDropdown, setShowVendorDropdown] = useState(false);
  const [showTruckDropdown, setShowTruckDropdown] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [progress, setProgress] = useState({});
  const [disabled, setIsDisabled] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [backupSortedData, setBackupSortedData] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    recordId: null,
    tripId: null
  });
  const [editValues, setEditValues] = useState({});

  const [filterReports, setFilterReports] = useState({
    startDate: '',
    endDate: '',
    vendor: '',
    truckNumber: ''
  });

  const [isLoading, setIsLoading] = useState(false);

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

    // Modal handler functions
  const showModal = (title, message, type = 'info') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };


  let grandTotal = 0;


  const calculateTotal = (row) => {
    // const currentRecord = destinations.filter(destination => 
    //         destination.from.toLowerCase() === row.toLowerCase() &&
    //         destination.to.toLowerCase() === row.toLowerCase()
    //     )

    const freight = parseFloat(row.Freight) || 0;
    const TDS_val = parseFloat(row.TDS_Rate) || 0;
    const short = parseFloat(row.Short) || 0;
    const differenceInWeight = parseFloat(row.DifferenceInWeight) || 0;
    const dieselAmount = parseFloat(row.DieselAmount) || 0;
    const advance = parseFloat(row.Advance) || 0;
    const toll = parseFloat(row.Toll) || 0;
    const adblue = parseFloat(row.Adblue) || 0;
    const greasing = parseFloat(row.Greasing) || 0;

    grandTotal += (Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing)));

    return Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing));
  };

  useEffect(() => {
    sessionStorage.setItem('actMod', 'reports');
    setActiveModule(sessionStorage.getItem('actMod'));

  }, []);

  const handleDelete = async (id, tripID) => {

    setDeleteModal({
      isOpen: true,
      recordId: id,
      tripId: tripID
    });

  }

  const confirmDelete = async () => {
    try {
      await axios.delete(`/api/reports/${deleteModal.recordId}`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        }
      });

      // Remove the deleted item from the table
      const updatedData = tableData.filter(item => item._id !== deleteModal.recordId);
      setTableData(updatedData);
      setBackupSortedData(updatedData);

      // Close modal
      setDeleteModal({ isOpen: false, recordId: null, tripId: null });

      // Show success notification (you could add a toast notification system here)
      setTimeout(() => {
        showModal('Success', 'Record deleted successfully!', 'success');
      }, 700);

    } catch (error) {
      console.error('Error deleting record:', error);

      let errorMessage = 'Error deleting record';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      showModal('Error', errorMessage, 'error');
    }
  };


  const formatTime = (time) => {
    const [timePart, ampm] = time.split(' ');
    const [hour, minutes] = timePart.split(':');

    let formattedTime = `${hour}:${minutes} ${ampm}`;

    return formattedTime;
  }


  const handleDownload = async (id, field, originalname) => {
    try {

      const response = await axios.get(`/api/download/${id}/${field}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
          responseType: 'blob' // Important: This tells axios to handle the response as a binary blob

        },
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      // Create a download link and trigger it
      saveAs(blob, originalname || 'download');

    } catch (error) {
      console.log('Download error:', error.message);
      showModal('Download Error', 'Error downloading file. Please try again.', 'error');
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close vendor dropdown if click is outside
      console.log('closest:', event.target.closest('.d1'));
      if (showVendorDropdown && !event.target.closest('.d1')) {
        setShowVendorDropdown(false);
      }
      // Close truck dropdown if click is outside
      if (showTruckDropdown && !event.target.closest('.d2')) {
        setShowTruckDropdown(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showVendorDropdown, showTruckDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.d3')) {
        if (editMode) {
          setTableData([...backupSortedData]);
        }
        setEditingRow(null);
        setIsDisabled(false);
        setSelectedFiles({});
        setEditMode(false);
        setProgress(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, [editMode, backupSortedData]);


  useEffect(() => {
    // Fetch vendors and truck numbers for dropdowns
    fetchVendors();
    fetchTruckNumbers();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if ((filterReports.startDate && filterReports.endDate) || filterReports.vendor || filterReports.truckNumber) {
        console.log('filterReports: ', filterReports);

        if (!(filterReports.startDate && filterReports.endDate) && !filterReports.vendor && !filterReports.truckNumber) {
          showModal('Error', 'Please select at least one filter', 'error');
          return;
        }

        if (((filterReports.startDate && !filterReports.endDate) || (!filterReports.startDate && filterReports.endDate)) && filterReports.truckNumber) {
          showModal('Error', 'Please select both start-date and end-date', 'error');
          return;
        }

        try {
          const response = await axios.get('/api/reports', {
            params: filterReports,
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            }
          });

          console.log('table data :', response.data.tableData);
          setTableData(response.data.tableData);
        } catch (err) {
          console.error('Error fetching the data:', err.message);
        }
      }
    };

    fetchData();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.get('/api/vendors',
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      setVendors(response.data.vendorData);
      console.log(vendors);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const fetchTruckNumbers = async () => {
    try {
      const response = await axios.get('/api/trucks',
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      setTruckNumbers(response.data.truckData);
      console.log(truckNumbers);

    } catch (error) {
      console.error('Error fetching truck numbers:', error);

    }
  };

  const filteredVendors = vendors.filter((vendor) =>
    vendor.company_name.toLowerCase().startsWith(vendorQuery.toLowerCase())
  )

  const filteredTrucks = truckNumbers.filter((truck) =>
    truck.truck_no.toLowerCase().includes(truckQuery.toLowerCase())
  );



  const handleFilterChange = (e) => {
    setFilterReports({
      ...filterReports,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsLoading(true);
    setShowTruckDropdown(false);
    setShowVendorDropdown(false);
    // let StartDate = new Date(filterReports.startDate).setHours(0, 0, 0, 0);
    // let EndDate = new Date(filterReports.endDate).setHours(23, 59, 59, 999);

    // setFilterReports({
    //   ...filterReports,
    //   startDate: StartDate,
    //   endDate: EndDate
    // })

    grandTotal = 0; // Reset grand total for each search

    console.log('filterReports: ', filterReports);
    if (!(filterReports.startDate && filterReports.endDate) && !filterReports.vendor && !filterReports.truckNumber) {
      setIsLoading(false);
      showModal('Error', 'Please select at least one filter', 'error');
      return;
    }

    if (((filterReports.startDate && !filterReports.endDate) || (!filterReports.startDate && filterReports.endDate)) && filterReports.truckNumber) {
      setIsLoading(false);
      showModal('Error', 'Please select both start-date and end-date', 'error');
      return;
    }

    try {
      const response = await axios.get('/api/reports', {
        params: filterReports,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        }
      }
      );
      console.log('table data :', response.data.tableData);
      //changes made that to made in deployed branch
      // const sortedData = response.data.tableData.sort((a, b) =>
      //   new Date(b.createdAt) - new Date(a.createdAt)
      // );
      setTableData(response.data.tableData);
      setIsLoading(false);
      //till here

      if (!response.data.tableData || response?.data?.tableData?.length === 0) {
        showModal('Info', 'No records available', 'info');
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching reports:', error);

      // Improved error handling
      let errorMessage = 'Error fetching Table data';

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      showModal('Error', errorMessage, 'error');
    }
  };

  const handleEdit = (rowId) => {
    setBackupSortedData([...tableData]);
    setEditingRow(rowId);
    setIsDisabled(false);
    setSelectedFiles({});
    setEditMode(true);
  };


  const handleFileSelect = async (e, rowId, fieldName) => {

    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if ((file.size / (1024 * 1024)) > 1) {
      e.target.value = '';
      showModal('File Size Exceeded', `File size is ${(file.size / (1024 * 1024)).toFixed(2)} mb. Please upload file upto 1 mb`, 'warning');
      return;
    }

    // if(!file.type.startsWith('image/')) {
    //   // Option 1: Using alert directly
    //   alert('Please upload only image files');
    //   // Clear the file input
    //   e.target.value = '';
    //   return;
    // }


    // let compressedBlob = '';
    // let compressedFile= '';

    // // When you get a file from e.target.files[0], you actually get a File object, which is a specific type of Blob. 
    // // The key difference is that a File object includes additional metadata like name, lastModified, and type, which
    // // is crucial for proper file handling.
    // // This is why the compression result needs to be converted back to a File object - it's still a Blob, but it's 
    // // missing the metadata that makes it a proper File. When the server receives a File object, it knows how to 
    // // handle it properly, including the filename and type.

    // const options = {
    //   maxSizeMB: 2,  // Increased max size to allow for better quality
    //   maxWidthOrHeight: 2048, // Higher resolution limit
    //   initialQuality: 0.8, // Higher initial quality
    //   useWebWorker: true,
    //   // Add specific options for better text readability
    //   fileType: 'image/*',
    //   stripMetadata: true,
    //   // If the image is already small, don't compress it further
    //   onProgress: () => {},
    //   signal: undefined,
    //   preserveExif: true
    // }

    // try{
    //   console.log('file size',file.size/(1024*1024))
    //   if ((file.size/(1024*1024)) < 2) {
    //     // If file is under 2MB, use it as is
    //     compressedFile = file;
    //   } else {
    //   compressedBlob = await imageCompression(file,options);

    //  compressedFile = new File(
    //     [compressedBlob], 
    //     file.name,  // Keep original filename
    //     { 
    //       type: file.type,  // Keep original file type
    //       lastModified: new Date().getTime()
    //     }
    //   );
    // }
    // console.log('compressed image file size', (compressedFile.size/(1024*1024)))

    // }catch(error){
    //   console.error(error.message);
    // }

    setSelectedFiles({
      ...selectedFiles,
      [`${rowId}-${fieldName}`]: file
    });

  };

  const handleSave = async (row) => {

    const updatedRow = {
      ...row,
      ...(editValues[row._id] || {})  // Apply any edits from editValues
    };

    if (!updatedRow.TransactionStatus) {
      showModal('Validation Error', 'Please select a valid transaction status', 'error');
      return;

    }

    setIsDisabled(true);
    setProgress({});
    const formData = new FormData();
    formData.append('id', updatedRow._id);
    formData.append('localDate', updatedRow.localDate);
    formData.append('transactionStatus', updatedRow.TransactionStatus);
    formData.append('weight', updatedRow.Weight);
    formData.append('actualWeight', updatedRow.ActualWeight);
    formData.append('short', updatedRow.Short);


    const fieldNames = {};
    // Append any selected files
    Object.keys(selectedFiles).forEach(key => {
      if (key.startsWith(updatedRow._id)) {
        const fieldName = key.split('-')[1];
        formData.append(fieldName, selectedFiles[key]);
        fieldNames[fieldName] = 0;
      }
    });

    try {
      const response = await axios.post(`/api/reports/${updatedRow._id}`, formData,
        {
          withCredentials: true,
          onUploadProgress: (ProgressEvent) => {
            const percentCompleted = Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total);

            setProgress((prevProgress) => ({
              ...prevProgress,
              ...Object.keys(fieldNames).reduce((acc, name) => {
                acc[name] = percentCompleted;
                return acc;
              }, {}),
            }))
          }
        });

      // Refresh data
      const updatedResponse = await axios.get('/api/reports', {
        params: filterReports,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        }
      }
      );
      setProgress({});
      setIsDisabled(false);

      //changes made that to made in deployed branch
      // const sortedUpdatedData = response.data.tableData.sort((a, b) =>
      //   new Date(b.createdAt) - new Date(a.createdAt)
      // );
      setTableData(updatedResponse.data.tableData);
      setBackupSortedData(updatedResponse.data.tableData);
      //till here

      setEditingRow(null);
      setSelectedFiles({});

      if (response.data && response.data.message) {
        console.log('response:', response.data.message);

        setTimeout(() => {
          showModal('Success', response.data.message, 'success');
        }, 500);

      }
    } catch (error) {
      setProgress({});
      setIsDisabled(false);
      if (error.response.data.message) {
        showModal('Error', error.response.data.message, 'error');
      }
      else {
        showModal('Error', 'Error updating the record', 'error');
      }
    }
  };

  const downloadExcel = () => {

    grandTotal = 0; // Reset grand total for each download

    const ExcelData = tableData.map(row => {

      const { userProfile, DieselSlipImage, LoadingAdvice, InvoiceCompany, WeightmentSlip, _id, TripID, Username, Profile, TruckNumber, DONumber, createdAt, updatedAt, __v, DriverName, Vendor, DestinationFrom, DestinationTo, TruckType, TransactionStatus, Weight, ActualWeight, DifferenceInWeight, Freight, DieselAmount, DieselSlipNumber, TDS_Rate, Short, Advance, Toll, Adblue, Greasing, BillId, localDate, localTime } = row;


      // Calculate the total WITHOUT modifying grandTotal
      const freight = parseFloat(row.Freight) || 0;
      const TDS_val = parseFloat(row.TDS_Rate) || 0;
      const short = parseFloat(row.Short) || 0;
      const dieselAmount = parseFloat(row.DieselAmount) || 0;
      const advance = parseFloat(row.Advance) || 0;
      const toll = parseFloat(row.Toll) || 0;
      const adblue = parseFloat(row.Adblue) || 0;
      const greasing = parseFloat(row.Greasing) || 0;


      const total = Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing));

      grandTotal += total;

      return {
        "Trip ID": TripID,
        "Username": Username,
        "Profile": Profile,
        "Truck Number": TruckNumber,
        "DO": DONumber,
        "Date": localDate,
        // "Time": formatTime(localTime),
        "Driver": DriverName,
        "Vendor": Vendor,
        "From": DestinationFrom,
        "To": DestinationTo,
        "Truck Type": TruckType,
        "Transaction": TransactionStatus,
        "Wt.": Weight,
        "A. Wt.": ActualWeight,
        "Diff. Wt.": DifferenceInWeight,
        ...((userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && { "Freight": Freight }),
        "Diesel": DieselAmount,
        "Dsl. Slp. No.": DieselSlipNumber,
        "TDS": (Freight * (TDS_Rate / 100)).toFixed(2),
        "Short": Short,
        "Adv.": Advance,
        "Toll": Toll,
        "Adblue": Adblue,
        "Greasing": Greasing,
        "Bill ID": BillId,
        "Amount": total

      }
    });


    const worksheet = XLSX.utils.json_to_sheet(ExcelData);


    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 },  // Trip ID
      { wch: 15 },  // Username
      { wch: 20 },  // Profile
      { wch: 12 },  // Truck Number
      { wch: 12 },  // DO Number
      { wch: 12 },  // Date
      // { wch: 10 },  // Time
      { wch: 15 },  // Driver Name
      { wch: 15 },  // Vendor
      { wch: 18 },  // Destination From
      { wch: 18 },  // Destination To
      { wch: 15 },  // Truck Type
      { wch: 20 },  // Transaction Status
      { wch: 10 },  // Weight
      { wch: 15 },  // Actual Weight
      { wch: 15 },  // Difference In Weight
      (userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') ? { wch: 15 } : null,// Freight
      { wch: 15 },  // Diesel Amount
      { wch: 15 },  // Diesel Slip Number
      { wch: 10 },  // TDS Rate
      { wch: 10 },  // Short
      { wch: 10 },  // Advance
      { wch: 10 },  // Toll
      { wch: 10 },  // Adblue
      { wch: 10 },  // Greasing
      { wch: 10 }   // Bill ID
    ];


    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, 'Reports.xlsx');
  };


  const groupDataByDate = (data) => {
    const grouped = {};

    data.forEach(item => {
      const date = item.localDate

      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(item);
    });

    return grouped;
  }

  function formatToReadableDate(dateStr) {
    const [dd, mm, yyyy] = dateStr.split('/');

    const day = parseInt(dd, 10);
    const monthIndex = parseInt(mm, 10) - 1; // JS months are 0-based
    const year = parseInt(yyyy, 10);

    const date = new Date(year, monthIndex, day);

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Add ordinal suffix
    function getDayWithSuffix(day) {
      if (day > 3 && day < 21) return `${day}th`;
      switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
      }
    }

    return `${getDayWithSuffix(day)} ${monthNames[monthIndex]}, ${year}`;
  }


  return (
    <div className="reports-container">
      <AlertModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
      <div className="filter-box">
        <form onSubmit={handleSubmit}>
          <div className="filters-grid">
            <div className="filter-item">
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={filterReports.startDate}
                onChange={handleFilterChange}
              />
            </div>

            <div className="filter-item">
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={filterReports.endDate}
                onChange={handleFilterChange}
              />
            </div>

            <div className="filter-item d1">
              <label>Vendor</label>
              <input
                type="text"
                placeholder='Search Vendor'
                name="vendor"
                autoComplete="off"
                value={vendorQuery}
                onChange={(e) => {
                  setVendorQuery(e.target.value)
                  handleFilterChange(e);
                }}
                onClick={() => setShowVendorDropdown(true)}

              />
              {showVendorDropdown && (
                <ul className="dropdown">
                  {filteredVendors.map((vendor) => (
                    <li
                      key={vendor._id}
                      onClick={() => {
                        setFilterReports({ ...filterReports, vendor: vendor.company_name });
                        setVendorQuery(vendor.company_name);
                        setShowVendorDropdown(false);
                      }}
                      style={{
                        padding: '5px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #ddd',
                      }}
                    >
                      {vendor.company_name}
                    </li>
                  ))}
                  {filteredVendors.length === 0 && (
                    <li style={{ padding: '5px' }}>No vendors found</li>
                  )}
                </ul>
              )}
            </div>

            <div className="filter-item d2">
              <label>Truck Number</label>
              <input
                type="text"
                name="truckNumber"
                placeholder='Search Truck'
                autoComplete="off"
                value={(truckQuery).toUpperCase()}
                onChange={(e) => {
                  setTruckQuery(e.target.value);
                  handleFilterChange(e);

                }}
                onClick={() => setShowTruckDropdown(true)}

              />
              {showTruckDropdown && (
                <ul className="dropdown">
                  {filteredTrucks.map((truck) => (
                    <li
                      key={truck._id}
                      onClick={() => {
                        setFilterReports({ ...filterReports, truckNumber: truck.truck_no });
                        setTruckQuery(truck.truck_no);
                        setShowTruckDropdown(false);
                      }}
                      style={{
                        padding: '5px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #ddd',
                      }}
                    >
                      {truck.truck_no}
                    </li>
                  ))}
                  {filteredTrucks.length === 0 && (
                    <li style={{ padding: '5px' }}>No trucks found</li>
                  )}
                </ul>
              )}
            </div>
          </div>

          <div className="button-group">
            <button type="submit" className="search-btn">Search</button>
            {/* <button type="button" className="today-list-btn" onClick={todayList}>Today's List</button> */}
            {tableData.length > 0
              && (
                <button type="button" className="download-btn" onClick={downloadExcel}>
                  Download Excel
                </button>
              )}
          </div>
        </form>
      </div>

      {isLoading && (
        <div className='table-wrapper'>
          <div className='spinner-container'>
            <div className='spinner'></div>
            <p>Loading reports...</p>
          </div>
        </div>
      )}

      {!isLoading && tableData.length > 0 && (
        <div className="table-box">
          {Object.entries(groupDataByDate(tableData)).map(([date, rows]) => (
            <div key={date} className="date-group-container">
              <h3 className='date-header'>
                {console.log('rows:', rows)}
                <span className='dateText'>{formatToReadableDate(rows[0].localDate)}</span>
              </h3>
              <div className={`table-responsive ${rows.some(row => editingRow === row._id) ? 'd3' : ''}`}>
                <table>
                  <thead id='sticky-header'>
                    <tr>
                      <th className='stickyColumnTH'>Trip ID</th>
                      <th>Username</th>
                      <th>Profile</th>
                      <th>Truck Number</th>
                      <th>DO</th>
                      <th>Date</th>
                      {/* <th>Time</th> */}
                      <th>Driver</th>
                      <th>Vendor</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Truck Type</th>
                      <th>Transaction</th>
                      <th>Wt.</th>
                      <th>A. Wt.</th>
                      <th>Diff. Wt.</th>
                      {(userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && <th>Freight</th>}
                      {/* <th>Diesel</th> */}
                      <th>Diesel</th>
                      <th className='DieselSlip'>Dsl. Slp. No.</th>
                      <th>TDS</th>
                      <th>Short</th>
                      <th>Adv.</th>
                      <th>Toll</th>
                      <th>Adblue</th>
                      <th>Greasing</th>
                      <th>Bill Id</th>
                      <th>Amount</th>
                      <th className='uploadTD'>Diesel Slip</th>
                      <th className='uploadTD'>Loading Advice</th>
                      <th className='uploadTD'>Invoice Company</th>
                      <th className='uploadTD'>Weightment Slip</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map(row => (
                      <tr key={row._id} className='table-row'>
                        <td
                          onClick={() => {
                            setModuleChange('/home');
                            setTripIDState(row);
                            Navigate(`/home/${row.TripID}`, { state: row })
                          }}
                          className='trip-id stickyColumnTD'
                        >{row.TripID}</td>
                        <td>{row.Username}</td>
                        <td>{row.Profile}</td>
                        <td>{row.TruckNumber}</td>
                        <td>{row.DONumber}</td>
                        <td>
                          {(editingRow === row._id) ? (
                            <input
                              className='editInput'
                              type="string"
                              value={editValues[row._id]?.localDate ?? row.localDate}
                              onChange={(e) => {
                                // const newData = tableData.map(item =>
                                //   item._id === row._id
                                //     ? { ...item,localDate: e.target.value }
                                //     : item
                                // );
                                // setTableData(newData);

                                setEditValues({
                                  ...editValues,
                                  [row._id]: {
                                    localDate: e.target.value
                                  }
                                })
                              }}
                            />
                          ) : (
                            row.localDate
                          )}
                        </td>
                        {/* <td>{formatTime(row.localTime)}</td> */}
                        <td>{row.DriverName}</td>
                        <td>{row.Vendor}</td>
                        <td>{row.DestinationFrom}</td>
                        <td>{row.DestinationTo}</td>
                        <td>{row.TruckType}</td>
                        <td>
                          {editingRow === row._id ? (
                            <select
                              value={row.TransactionStatus}
                              onChange={(e) => {
                                const newData = tableData.map(item =>
                                  item._id === row._id
                                    ? { ...item, ...(e.target.value && { TransactionStatus: e.target.value }) }
                                    : item
                                );
                                setTableData(newData);
                              }}
                            >
                              <option value="">Select Transaction Status</option>
                              <option value="Open">Open</option>
                              <option value="Acknowledged">Acknowledged</option>

                            </select>
                          ) : (
                            row.TransactionStatus
                          )}</td>
                        <td>
                          {(editingRow === row._id && userProfile !== 'loadingManager') ? (
                            <input
                              className='editInput'
                              type="number"
                              value={row.Weight}
                              onChange={(e) => {
                                const newData = tableData.map(item =>
                                  item._id === row._id
                                    ? { ...item, Weight: e.target.value }
                                    : item
                                );
                                setTableData(newData);
                              }}
                            />
                          ) : (
                            row.Weight
                          )}
                        </td>
                        <td>
                          {editingRow === row._id ? (
                            <input
                              className='editInput'
                              type="number"
                              value={row.ActualWeight}
                              onChange={(e) => {
                                const newData = tableData.map(item =>
                                  item._id === row._id
                                    ? { ...item, ActualWeight: e.target.value }
                                    : item
                                );
                                setTableData(newData);
                              }}
                            />
                          ) : (
                            row.ActualWeight
                          )}
                        </td>
                        <td>
                          {row.DifferenceInWeight}
                        </td>
                        {(userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && <td>{row.Freight}</td>}
                        {/* <td>{row.Diesel}</td> */}
                        <td>{row.DieselAmount}</td>
                        <td>{row.DieselSlipNumber}</td>
                        <td>{(row.Freight * (row.TDS_Rate / 100)).toFixed(2)}</td>
                        <td>
                          {(editingRow === row._id) ? (
                            <input
                              className='editInput'
                              type="number"
                              value={row.Short}
                              onChange={(e) => {
                                const newData = tableData.map(item =>
                                  item._id === row._id
                                    ? { ...item, Short: e.target.value }
                                    : item
                                );
                                setTableData(newData);
                              }}
                            />
                          ) : (
                            row.Short
                          )}
                        </td>
                        <td>{row.Advance}</td>
                        <td>{row.Toll}</td>
                        <td>{row.Adblue}</td>
                        <td>{row.Greasing}</td>
                        <td>{row.BillId}</td>
                        <td>{calculateTotal(row)}</td>
                        {['DieselSlipImage', 'LoadingAdvice', 'InvoiceCompany', 'WeightmentSlip'].map(field => (
                          <td key={field} className="uploadTD">
                            {editingRow === row._id ? (
                              <>
                                <input
                                  type="file"
                                  name={field}
                                  onChange={(e) => handleFileSelect(e, row._id, field)}
                                  accept=".pdf,application/pdf"
                                  max="1"
                                />
                                {progress[field] > 0 && (
                                  <div className="progress-bar">
                                    <div className="progress-fill" style={{ width: `${progress[field]}%` }}></div>
                                  </div>
                                )}
                              </>
                            ) : row[field]?.filepath ? (
                              <button
                                className="download-link-btn"
                                onClick={() => handleDownload(row._id, field, row[field].originalname)}
                              >
                                Download {row[field].originalname}
                              </button>
                            ) : (
                              'No file'
                            )}
                          </td>
                        ))}

                        <td>
                          {editingRow === row._id ? (
                            <button
                              disabled={disabled}
                              className="save-btn"
                              onClick={() => handleSave(row)}
                            >
                              Save
                            </button>
                          ) : (
                            <button
                              className="edit-btn"
                              onClick={() => handleEdit(row._id)}
                            >
                              Edit
                            </button>
                          )}
                        </td>

                        {(userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && <td>

                          <button
                            className='delete-btn'
                            onClick={() => handleDelete(row._id, row.TripID)}
                          >
                            Delete
                          </button>
                        </td>}
                      </tr>

                    ))}
                  </tbody>
                </table>

                {deleteModal.isOpen && (
                  <div className="delete-modal-overlay">
                    <div className="delete-modal">
                      <div className="delete-modal-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="54" height="54">
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path fill="#ff4757" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z" />
                        </svg>
                      </div>
                      <h3>Confirm Delete</h3>
                      <p>Are you sure you want to delete record having Trip ID: <span className="trip-id-highlight">{deleteModal.tripId}</span>?</p>
                      <p className="warning-text">This action cannot be undone.</p>
                      <div className="delete-modal-buttons">
                        <button className="cancel-btn" onClick={() => setDeleteModal({ isOpen: false, recordId: null, tripId: null })}>
                          Cancel
                        </button>
                        <button className="confirm-delete-btn" onClick={confirmDelete}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}

        </div>
      )}
    </div>
  );
};

export default Reports;